module.exports = __webpack_public_path__ + "img/TV_android-series_X8000G.bef15caf.png";